module.exports = __webpack_public_path__ + "static/media/calendar.b2636362.png";